import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function PricingSection() {
  return <section className="py-20 px-4 bg-[#5C6B60] text-white overflow-hidden relative" data-id="element-116">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-117">
        <div className="absolute top-[-20%] right-[-10%] w-[500px] h-[500px] bg-white rounded-full blur-3xl" data-id="element-118" />
        <div className="absolute bottom-[-20%] left-[-10%] w-[500px] h-[500px] bg-[#C2644C] rounded-full blur-3xl" data-id="element-119" />
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-120">
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/20 shadow-2xl" data-id="element-121">
          <p className="text-[#F5F1EA]/80 text-lg mb-2 font-medium" data-id="element-122">
            Valor real del programa + bonos:{' '}
            <span className="line-through decoration-[#C2644C] decoration-2" data-id="element-123">
              $62.900
            </span>
          </p>

          <div className="mb-8" data-id="element-124">
            <span className="text-2xl text-[#F5F1EA] mr-2" data-id="element-125">Hoy:</span>
            <span className="text-6xl md:text-7xl font-bold text-white tracking-tight" data-id="element-126">
              $17.900
            </span>
          </div>

          <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWN97cYIrZq0N6nxejFJOld3/es-ar?_r=AQABO5WkZAviKo3oQFFbDGNAwsqGY8jRmCI-2Na28krQ6Q0&preview_theme_id=163563503651" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto mb-6" data-id="element-127">
            <Button variant="primary" size="lg" className="w-full md:w-auto text-lg md:text-xl py-8 px-10 rounded-full shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 group" data-id="element-128">
              QUIERO ACTIVAR LA LECTURA EN CASA
              <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-129" />
            </Button>
          </a>

          <p className="text-sm text-[#F5F1EA]/70" data-id="element-130">
            Pago único. Recibis acceso de inmediado detodo el material a tu MAIL. Garantía de satisfacción.      
                           COMPRA PROTEGIDA POR MERCADO PAGO
          </p>
        </div>
      </div>
    </section>;
}